import { abbrevGameName, FILTER_DESCRIPTION } from "../game";

export const filterHideFlasksByAreaLevel =
`Hide # Life and Mana Flasks - Lesser and Medium (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Lesser" "Medium"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 15

Hide # Life and Mana Flasks - Grand and Greater (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Grand" "Greater"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 25

Hide # Life and Mana Flasks - Giant (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Giant"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 32

Hide # Life and Mana Flasks - Colossal (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Colossal"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 42

Hide # Life and Mana Flasks - Gargantuan (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Gargantuan"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 52

Hide # Life and Mana Flasks - Transcendent (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Transcendent"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 62

Hide # Life and Mana Flasks - Ultimate Normal (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Ultimate"
  Quality 0
  Rarity Normal
  AreaLevel >= 65

Hide # Life and Mana Flasks - Ultimate < 10 Quality (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Ultimate"
  Quality < 10
  Rarity <= Magic
  AreaLevel >= 70

Hide # Life and Mana Flasks - Ultimate < 15 Quality (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Ultimate"
  Quality < 15
  Rarity <= Magic
  AreaLevel >= 75

Hide # Life and Mana Flasks - Ultimate < 20 Quality (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Ultimate"
  Quality < 20
  Rarity <= Magic
  AreaLevel >= 80
`;

export const filterHideFlasksByAreaLevelPoe1LifeMana =
`Hide # Life and Mana Flasks - Large, Medium and Small (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Large" "Medium" "Small"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 15
  DisableDropSound

Hide # Life and Mana Flasks - Grand and Greater (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Grand" "Greater"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 30
  DisableDropSound

Hide # Life and Mana Flasks - Colossal, Giant, Sacred (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Colossal" "Giant" "Sacred"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 48
  DisableDropSound

Hide # Life and Mana Flasks - Hallowed and Sanctified (flasks-leveling-life-mana)
  Class == "Life Flasks" "Mana Flasks"
  BaseType "Hallowed" "Sanctified"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 60
  DisableDropSound
`;

export const filterHideFlasksByAreaLevelPoe1Hybrid =
`Hide # Hybrid Flasks - Small (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Small"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 20
  DisableDropSound

Hide # Hybrid Flasks - Medium (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Medium"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 30
  DisableDropSound

Hide # Hybrid Flasks - Large (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Large"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 40
  DisableDropSound

Hide # Hybrid Flasks - Colossal (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Colossal"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 50
  DisableDropSound

Hide # Hybrid Flasks - Sacred (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Sacred"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 60
  DisableDropSound

Hide # Hybrid Flasks - Hallowed (flasks-leveling-hybrid)
  Class == "Hybrid Flasks"
  BaseType "Hallowed"
  Quality 0
  Rarity <= Magic
  AreaLevel >= 67
  DisableDropSound
`;

export const filterHideSingleScrolls =
`Hide # Single Scrolls (scroll-of-wisdom)
  BaseType == "{type}"
  Class == "Stackable Currency"
  StackSize == 1
  DisableDropSound

Show # Double Scrolls (scroll-of-wisdom)
  StackSize 2
  BaseType == "{type}"
  Class == "Stackable Currency"
`;

export const filterHideScrolls =
`Hide # Scrolls (scroll)
  BaseType == "{type}"
  Class == "Stackable Currency"
  StackSize <= {minScrolls}
  DisableDropSound
`;

export const filterDefaultMinLabelSize =
`Show # Default Label Size (label-size)
  SetFontSize {minLabelSize}
  Continue
`;

export const filterHeader = `
#######################################################
### {header}
#######################################################
`;

export const filterTemplate =
`#######################################################
### General Partial Rules
#######################################################

{minLabelSize}

#######################################################
### Cosmetic & Custom Rules
#######################################################

{filterFreeRulesTop}
{filterCustomCosmeticRules}
{filterCustomRules}

#######################################################
### Uniques & Chance Bases Rules
#######################################################

{filterHighlightUniques}
{filterHighlightChanceBases}

#######################################################
### Currency Rules
#######################################################

{filterHideGold}

{filterHideVerisium}

{filterHideScrolls}
{filterHidePortalScrolls}

#######################################################
### Map Rules
#######################################################

{filterWaystones}

#######################################################
### Crafting Base Rules
#######################################################

{filterHighlightCraftingBases}

#######################################################
### Favourite Gear Highlight Rules
#######################################################

{filterShowMyGearHighlights}

#######################################################
### Other Crafting Base Rules
#######################################################

{filterHighlightILevelCraftingBases}
{filterHighlightHighILevelFlasks}
{filterHighlightHighILevelCharms}
{filterHighlight6LinkedItems}

#######################################################
### Identified Item Rules
#######################################################

{filterHighlightIdentifiedItems}

#######################################################
### Restricted Mod Identified Item Rules
#######################################################

{filterHighlightRestrictedModIdentifiedItems}

#######################################################
### Favourite Gear Rules
#######################################################

{filterShowMyGear}

#######################################################
### Leveling Gear Rules
#######################################################

{filterShowLevelingGear}

{filterHideFlasksByAreaLevel}

#######################################################
### Other Gear Rules
#######################################################

{filterUnidentifiedGear}

{filterInfluencedGear}

{filterExaltRecipe}
{filterChaosRecipe}
{filterChromaticRecipe}
{filterShowJewellersRecipe}

#######################################################
### Socketed & Quality Gear Rules
#######################################################

{filterShowSocketed}
{filterShowQuality}
{filterShowQualityFlasks}
{filterShowQualityCharms}

#######################################################
### Remaining Gear Rules
#######################################################

{filterHideRemainingIdentifiedGear}
{filterHideGear}

#######################################################
### Favourite Jewellery Highlight Rules
#######################################################

{filterShowMyJewelleryHighlights}

{filterShowMyJewelsHighlights}

#######################################################
### Jewellery Highlight Rules
#######################################################

{filterHighlightInfluencedJewellery}
{filterHighlightVeiledJewellery}
{filterHighlightFracturedJewellery}
{filterHighlightMemoryStrandJewellery}
{filterHighlightAnointedAmulets}
{filterHighlightSpecialGear}
{filterHighlightCorruptedImplicitJewels}
{filterHighlightCorruptedImplicitJewellery}

#######################################################
### Cluster Jewel Base Rules
#######################################################

{filterHighlightClusterJewel}

#######################################################
### Favourite Jewellery Rules
#######################################################

{filterShowMyJewellery}

{filterShowMyJewels}

{filterShowMyFlasks}

#######################################################
### Other Jewellery Rules
#######################################################

{filterShowJewelleryShowSpecialBaseTypes}

{filterUnidentifiedJewellery}

#######################################################
### Remaining Jewellery Rules
#######################################################

{filterHideRemainingIdentifiedJewellery}

{filterHideJewellery}

{filterHideFlasksCharms}

#######################################################
### Gem Rules
#######################################################

{filterHighlightGems}

#######################################################
### Various Rules
#######################################################

{filterHighlightQuestItems}

#######################################################
### Other Rules
#######################################################

{filterHighlightTrialItems}
{filterHighlightHeist}

#######################################################
### Tiered Currency Rules
#######################################################

{tieredCurrency}

#######################################################
### Bottom Free-text Rules
#######################################################

{filterFreeRulesBottom}`;

export const filterPrefix = `#######################################################
### ${FILTER_DESCRIPTION}
#######################################################

`;

export const filterSuffix = `

#######################################################
### Filter Configuration
#######################################################
# Game: ${abbrevGameName}
# Version: {version}
# Export date: {date}
#######################################################
# [[Config Start]]
# {filterConfig}
# [[Config End]]
#######################################################`;
